import { api } from "@/lib/api";

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/media/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return process.env.REACT_APP_BACKEND_URL + data.url;
}
